import { NavigateFunction } from 'react-router-dom'
import { toLocaleCurrency } from 'utils/dinero'
import { URL_BENEFICIOS, URL_RENOVADOR } from 'config'

// Assets
import MoneyBag from 'assets/images/emojis/money-bag.png'
import Crown from 'assets/images/emojis/crown.png'
import GreenHeart from 'assets/images/emojis/green-heart.png'
import Thunderbolt from 'assets/images/emojis/thunderbolt.png'
import Card from 'assets/images/card.png'
import LineChart from 'assets/images/emojis/line-chart.png'
import Dialog from 'assets/images/emojis/dialog.png'
import Supermarket from 'assets/images/emojis/supermarket_emoji.png'

import Badge from 'components/Badge'

import { INTEREST_FREE_ADVANCE_MAX_AMOUNT } from './credit'

interface ActionParams {
  navigate: NavigateFunction
  token: string
}

export const HUB_MODALS = {
  advances: {
    icon: Thunderbolt,
    title: 'Adelantos al instante',
    content: (
      <>
        <p>Obtené dinero en el momento y devolvelo en cuotas.</p>
        <p>
          Además, todos los meses contás con hasta $
          {toLocaleCurrency(INTEREST_FREE_ADVANCE_MAX_AMOUNT)} disponibles para
          solicitar a Tasa 0%.
        </p>
      </>
    ),
    buttonText: 'Simular adelanto',
    action: ({ navigate }: ActionParams) =>
      navigate('/adelantos/tipo-de-adelanto')
  },
  cashback: {
    icon: Supermarket,
    title: 'Reintegros en supermercados',
    content: (
      <p>
        20% de reintegro en todos los supermercados del país pagando con tu
        tarjeta Wayni Mastercard. Tope de reintegro mensual: $5.000.
      </p>
    ),
    buttonText: 'Ingresar dinero',
    action: ({ navigate }: ActionParams) => navigate('/movimientos')
  },
  card: {
    icon: Card,
    title: 'Billetera virtual 100% gratis',
    content: (
      <>
        <p>
          Tenés una billetera digital para gestionar tu plata desde un solo
          lugar.
        </p>
        <p>
          Además, te damos una tarjeta MasterCard Prepaga bonificada para que
          compres donde quieras y extraigas efectivo.
        </p>
      </>
    ),
    buttonText: 'Solicitar tarjeta',
    action: ({ navigate }: ActionParams) => navigate('/mis-tarjetas')
  },
  preferentialRate: {
    icon: Crown,
    title: 'Tasas de interés preferenciales',
    content: (
      <p>
        Todos tus préstamos cuentan con importantes descuentos en la tasa de
        interés.
      </p>
    ),
    buttonText: 'Simular Préstamo',
    action: ({ token }: ActionParams) =>
      window
        .open(`${URL_RENOVADOR}iniciando?access_token=${token}`, '_blank')
        .focus()
  },
  higherAmounts: {
    icon: MoneyBag,
    title: 'Mayores montos',
    content: (
      <p>
        Tus líneas de crédito se actualizan todos los meses para que siempre
        tengamos algo nuevo que ofrecerte.
      </p>
    ),
    buttonText: 'Simular Préstamo',
    action: ({ token }: ActionParams) =>
      window
        .open(`${URL_RENOVADOR}iniciando?access_token=${token}`, '_blank')
        .focus()
  },
  creditProfile: {
    icon: LineChart,
    title: 'Tu perfil crediticio',
    content: (
      <>
        <p>
          Conocer tu calificación financiera te permite planificar mejor tus
          finanzas.
        </p>
        <p>
          Accedé a tu informe crediticio y maximizá tu potencial financiero.
        </p>
      </>
    ),
    buttonText: 'Ver mi perfil crediticio',
    action: ({ navigate }: ActionParams) => navigate('/perfil-crediticio')
  },
  help: {
    icon: Dialog,
    title: 'Atención por WhatsApp',
    content: (
      <p>
        Resolvé todas tus consultas a través de un chat directo con nosotros.
      </p>
    ),
    buttonText: 'Acceder al Centro de Ayuda',
    action: ({ navigate }: ActionParams) => navigate('/centro-de-ayuda')
  },
  benefits: {
    icon: GreenHeart,
    title: 'Wayni Beneficios',
    content: (
      <>
        <p>
          Nos unimos con Mastercard para darte acceso a la red de descuentos más
          grande.
        </p>
        <p>
          Ahorros en supermercados, tecnología, entretenimiento y mucho más.
        </p>
      </>
    ),
    buttonText: 'Ver beneficios',
    action: () => window.open(URL_BENEFICIOS, '_blank')
  }
}

export const HUB_BUTTONS = [
  {
    id: 'advances',
    icon: Thunderbolt,
    title: 'Adelantos al instante',
    description: `Tasa 0% para montos de hasta $${toLocaleCurrency(
      INTEREST_FREE_ADVANCE_MAX_AMOUNT
    )}.`,
    badge: (
      <Badge className='py-[3px]'>
        <span>Para vos</span>
      </Badge>
    ),
    eventName: 'bille_wayniplus_adelantos'
  },
  {
    id: 'cashback',
    icon: Supermarket,
    title: 'Reintegros en supermercados',
    description: '20% de reintegro usando tu tarjeta.'
  },
  {
    id: 'preferentialRate',
    icon: Crown,
    title: 'Tasas de interés preferenciales',
    eventName: 'bille_wayniplus_ti'
  },
  {
    id: 'card',
    icon: Card,
    title: 'Billetera virtual 100% gratis',
    eventName: 'bille_wayniplus_tarjetas'
  },
  {
    id: 'higherAmounts',
    icon: MoneyBag,
    title: 'Mayores montos',
    eventName: 'bille_wayniplus_mayores_montos'
  },
  {
    id: 'benefits',
    icon: GreenHeart,
    title: 'Wayni beneficios',
    eventName: 'bille_wayniplus_beneficios'
  },
  {
    id: 'creditProfile',
    icon: LineChart,
    title: 'Tu perfil crediticio',
    description: 'Maximizá tu potencial financiero.',
    eventName: 'bille_wayniplus_pc'
  },
  {
    id: 'help',
    icon: Dialog,
    title: 'Atención por WhatsApp',
    description: '100% personalizada.',
    eventName: 'bille_wayniplus_atc'
  }
]
